import { Component, OnInit, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { AuthConfigService } from '../../services/auth-config/auth-config.service';
import { ConfigService, CsrfService } from '@argalis-apps/angular-global';

@Component({
  selector: 'ags-connexion',
  templateUrl: './connexion.component.html',
  styleUrls: ['./connexion.component.scss']
})
export class ConnexionComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() landingRoute: string[];
  @Input() popupMode: boolean;
  @Output() popupLeave = new EventEmitter();
  @Input() renewPopup: boolean;
  @Output() renewEmit = new EventEmitter();
  @Output() changePasswordPopup = new EventEmitter();
  @Input() changePasswordPopupMode = false;
  @Input() public accountCreation = false;

  public loginError = false;
  public submitted: boolean = void 0;
  public invalidMdp = false;
  public invalidLogin = false;
  public loginForm: UntypedFormGroup;

  constructor(
    private authConfigService: AuthConfigService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private csrfService: CsrfService,
    private configService: ConfigService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${this.authConfigService.themingClassName}`;
    this.accountCreation = authConfigService.isCreationAuthorized();
    this.loginForm = this.formBuilder.group({
      login: new UntypedFormControl(null, [Validators.required, Validators.email]),
      mdp: new UntypedFormControl(null, [Validators.required])
    });
  }

  ngOnInit() {}

  signin() {
    this.invalidMdp = this.loginForm.get('mdp').invalid;
    this.invalidLogin = this.loginForm.get('login').invalid;
    const login: string = this.loginForm.get('login').value || '';
    const password: string = this.loginForm.get('mdp').value || '';

    if (this.loginForm.valid) {
      this.loginError = false;
      this.submitted = true;
      this.authService.signin(login, password).subscribe(
        (result: any) => {
          if (result) {
            if (!this.configService.getOptions().useTestData && result.user) {
              this.authService.userChangeNext(result.user);
            }
            this.submitted = false;
            this.loginError = false;
            this.loginForm.reset();
            if (result.csrf) this.csrfService.setToken(result.csrf);
            if (this.changePasswordPopupMode) this.changePasswordPopup.emit(result);
            if (this.popupMode) this.popupLeave.emit();
            if (this.landingRoute && this.landingRoute.length > 0 && !this.changePasswordPopupMode) {
              this.router.navigate(this.landingRoute);
            }
            if (this.changePasswordPopupMode && !result.user.password_renew) {
              this.router.navigate(this.landingRoute);
            }
          }
        },
        err => {
          this.submitted = false;
          this.loginError = true;
          console.error(`${new Date().toISOString()} NOPE :`, err);
        }
      );
    }
  }

  public getLinksRoute(routeName: string): string[] {
    return this.authService.getRoute(routeName);
  }
}
